var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:_vm.classes},[_c('div',{staticClass:"g_restrict"},[_c('logo-nespresso'),_c('selector-language')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }